import { render, staticRenderFns } from "./detailBGLogin.vue?vue&type=template&id=1689a5ef&scoped=true"
import script from "./detailBGLogin.vue?vue&type=script&lang=js"
export * from "./detailBGLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1689a5ef",
  null
  
)

export default component.exports